import { ReactNode } from 'react';

import { FormatNumber } from 'utils/helpers';

import CabecalhoDaSecao from '../resumo/CabecalhoDaSecao';

export interface LinhaDoExtrato {
  chave: string;
  rotulo: string;
  pontos: number;
  /** Mensagens de renúncia ou de limite que a dinâmica já exibia. */
  avisos: string[];
  /** Abre a aba da dinâmica; ausente quando ela não tem detalhe para abrir. */
  onVerMais?: () => void;
}

interface ResumoProps {
  total?: number;
  linhas: LinhaDoExtrato[];
}

const LINHA = 'flex w-full flex-wrap items-center gap-3.5 rounded-xl bg-surface-100 px-5 py-3.5 text-left';

function ConteudoDaLinha({ linha, children }: { linha: LinhaDoExtrato; children?: ReactNode }) {
  return (
    <>
      <span className="flex min-w-[170px] flex-1 flex-col">
        <span className="text-sm text-content">{linha.rotulo}</span>
        {linha.avisos.map(aviso => (
          <span key={aviso} className="mt-1 block text-xs text-content-soft">
            {aviso}
          </span>
        ))}
      </span>
      <span className="whitespace-nowrap rounded-jj-pill bg-brand-purple-light px-[18px] py-2 font-display text-[15px] font-bold text-content">
        {FormatNumber(linha.pontos, false)} pontos
      </span>
      {children}
    </>
  );
}

function Chevron() {
  return (
    <svg
      data-chevron
      width="18"
      height="18"
      viewBox="0 0 24 24"
      fill="none"
      stroke="var(--brand-blue)"
      strokeWidth="2.6"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      focusable="false"
      className="shrink-0"
    >
      <path d="m9 6 6 6-6 6" />
    </svg>
  );
}

/** "Extrato do ciclo" do Resumo: a linha com detalhe é um botão só, que abre a aba da dinâmica (AJ2-13, AJ2-14). */
export default function Resumo({ total, linhas }: ResumoProps) {
  return (
    <section aria-labelledby="titulo-extrato-do-ciclo">
      <CabecalhoDaSecao id="titulo-extrato-do-ciclo" titulo="Extrato do ciclo" subtitulo="Pontos ganhos em cada programa" />

      <div className="flex flex-col gap-2.5 rounded-2xl bg-surface-0 px-6 py-[22px] shadow-jj-01">
        <div className="flex flex-wrap items-center gap-4 rounded-xl bg-brand-yellow-light px-5 py-4">
          <span className="min-w-[180px] flex-1 font-display text-[15px] font-bold text-content">Total de pontos do ciclo</span>
          <span className="inline-flex items-baseline gap-[7px] rounded-jj-pill bg-brand-blue px-[22px] py-2.5 font-display text-[22px] font-extrabold leading-none text-brand-white">
            {FormatNumber(total)}
            <span className="text-xs font-bold">pontos</span>
          </span>
        </div>

        <ul className="m-0 flex list-none flex-col gap-2.5 p-0">
          {linhas.map(linha => (
            <li key={linha.chave}>
              {linha.onVerMais ? (
                <button
                  type="button"
                  onClick={linha.onVerMais}
                  className={`${LINHA} cursor-pointer border-0 font-[inherit] transition-colors hover:bg-surface-200`}
                >
                  <ConteudoDaLinha linha={linha}>
                    <Chevron />
                  </ConteudoDaLinha>
                </button>
              ) : (
                <div className={LINHA}>
                  <ConteudoDaLinha linha={linha} />
                </div>
              )}
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}
